import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getLocalStorageData from '../utlis/storageUtils';
import { BASE_API_URL } from '../constants';
import { getHeaders } from '../utlis/security';

export const audioPurchasedBookPageApi = createApi({
  reducerPath: 'audioPurchasedBookPageApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: BASE_API_URL,
    prepareHeaders: async (headers) => {
      const customHeaders = await getHeaders('audioPurchasedBookPageApi');
      for (const [key, value] of Object.entries(customHeaders)) {
        headers.set(key, value);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchAudioPurchasedBookData: builder.query({
      query: ( option ) => ({
        url : 'https://snsapiv2.baganit.com/api/purchase/mypurchased',   // bookbyauthor
        method: 'POST',
        body : {
          "phone": "",
        //   "platform": "miniapp",
          "udid": "",  //190740e5f0032702
          "user_id":  getLocalStorageData(), //"959770179977", //getLocalStorageData() //JSON.parse(localStorage.getItem("userId"))
          // "version_code": 29,
          // "version_name": "1.2.9"
      },
      }), 
    })
  }),
});

export const { useFetchAudioPurchasedBookDataQuery } = audioPurchasedBookPageApi;